import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/header';
import { Stack } from '@mui/material';
import DownloadSection from '../components/download-section';
import FooterSection from '../components/footer-section';
import BlogSection from '../components/blog-section';
import { ARTICLES } from '../const/ARTICLES';

const BlogPage = () => {
  const { id } = useParams<{ id: string }>();

  const article = ARTICLES.find((article) => article.id.toString() === id);

  return (
    <Stack
      spacing={0}
      sx={{
        width: '100%',
      }}
    >
      <Header />
      {article && <BlogSection article={article} />}
      <DownloadSection />
      <FooterSection />
    </Stack>
  );
};

export default BlogPage;
